import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {resetUserDatabase} from "../../ducks/duck-game";
import {deleteUserAndData, fsResetEmailPassword} from "../../ducks/duck-user";

import ConfirmModal from "./confirm-modal";
import {
    TYPE_CONFIRM_DELETE,
    TYPE_CONFIRM_RESET_DATABASE,
    TYPE_CONFIRM_RESET_PASSWORD
} from "../../helpers/modal-builder";

function ConfirmModalContainer(props) {
	const { modal, removeModalWindow, resetUserDatabase, deleteUserAndData, email, fsResetEmailPassword } = props;

	let func = null;
	if(props.modal.type === TYPE_CONFIRM_RESET_DATABASE){
		func = () => {
			removeModalWindow();
			resetUserDatabase()
		}
	} else if(props.modal.type === TYPE_CONFIRM_DELETE){
		func = () => {
			removeModalWindow();
			deleteUserAndData();
		}
	} else if(props.modal.type === TYPE_CONFIRM_RESET_PASSWORD){
		func = () => {
			removeModalWindow();
			fsResetEmailPassword(email);
		}
	}

	if(func){
		return <ConfirmModal modal={modal}

		              onConfirm={() => {
			              func()
		              }}

		              onCancel={() => {
			              removeModalWindow();
		              }}
		/>
	} else {
		debugger;
		return <div/>
	}
}

ConfirmModalContainer.propTypes = {
	modal: PropTypes.object.isRequired,
	email: PropTypes.string,

	removeModalWindow: PropTypes.func.isRequired,
	resetUserDatabase: PropTypes.func.isRequired,
	fsResetEmailPassword: PropTypes.func.isRequired,
	deleteUserAndData: PropTypes.func.isRequired,
};

function mapStateToProps(state){
	return {
		email: state.userReducer.email,
	}
}

export default connect(
	mapStateToProps,
	{
		resetUserDatabase,
		deleteUserAndData,
		fsResetEmailPassword
	}
)(ConfirmModalContainer);
